/** Per-widget-key visitor token in localStorage; tolerates blocked storage (private mode). */
const keyFor = (widgetKey: string) => `vixsync:${widgetKey}:visitor`;

export function loadToken(widgetKey: string): string | null {
  try {
    return localStorage.getItem(keyFor(widgetKey));
  } catch {
    return null;
  }
}

export function saveToken(widgetKey: string, token: string): void {
  try {
    localStorage.setItem(keyFor(widgetKey), token);
  } catch {
    // Storage unavailable: the chat still works for this page view.
  }
}
